export default "<template>\n\n  <KButton\n    primary\n    disabled\n    text=\"Raised Button\"\n  />\n\n</template>\n";